'use strict';

/********************************/
// Click refresh
// Needs to be refactored
/********************************/
function clickRefresh() {
    var refreshSpan = document.getElementById('TTQrefreshbutton');
    var buttonsFieldArray = refreshSpan.getElementsByTagName('input');
    var TTQrefreshButton = buttonsFieldArray[0];
    TTQrefreshButton.click();
}

function clickRefresh2() {
    $('#dvLoading').fadeIn('slow');
    var refreshSpan = document.getElementById('TTQrefreshbutton2');
    var buttonsFieldArray = refreshSpan.getElementsByTagName('input');
    var TTQrefreshButton2 = buttonsFieldArray[0];
    TTQrefreshButton2.click(function () {
        $('#dvloader').fadeIn();
    });
}

function clickRefresh3() {
    $('#dvLoading').fadeIn('slow');
    var refreshSpan = document.getElementById('TTQrefreshbutton3');
    var buttonsFieldArray = refreshSpan.getElementsByTagName('input');
    var TTQrefreshButton3 = buttonsFieldArray[0];
    TTQrefreshButton3.click(function () {
        $('#dvloader').fadeIn();
    });
}

function clickRefresh4() {
    $('#dvLoading').fadeIn('slow');
    var refreshSpan = document.getElementById('TTQrefreshbutton4');
    var buttonsFieldArray = refreshSpan.getElementsByTagName('input');
    var TTQrefreshButton4 = buttonsFieldArray[0];
    TTQrefreshButton4.click(function () {
        $('#dvloader').fadeIn();
    });
}

function clickRefresh5() {
    $('#dvLoading').fadeIn('slow');
    var refreshSpan = document.getElementById('TTQrefreshbutton5');
    var buttonsFieldArray = refreshSpan.getElementsByTagName('input');
    var TTQrefreshButton5 = buttonsFieldArray[0];
    TTQrefreshButton5.click(function () {
        $('#dvloader').fadeIn();
    });
}

function clickRefresh6() {
    $('#dvLoading').fadeIn('slow');
    var refreshSpan = document.getElementById('TTQrefreshbutton6');
    var buttonsFieldArray = refreshSpan.getElementsByTagName('input');
    var TTQrefreshButton6 = buttonsFieldArray[0];
    TTQrefreshButton6.click(function () {
        $('#dvloader').fadeIn();
    });
}

function clickRefresh7() {
    $('#dvLoading').fadeIn('slow');
    var refreshSpan = document.getElementById('TTQrefreshbutton7');
    var buttonsFieldArray = refreshSpan.getElementsByTagName('input');
    var TTQrefreshButton7 = buttonsFieldArray[0];
    TTQrefreshButton7.click(function () {
        $('#dvloader').fadeIn();
    });
}

function sta_check4unicode() {

    /* jshint -W117 */
    if (!sits_non_unicode()) {
        return true;
    }
    /* jshint +W117 */

    // Javascript could be added here to add a message to the
    //   user that Unicode characters have been found.
    window.alert('Please replace foreign characters with English equivalents and try again');

    return false;
}

/********************************/
// Reload page
// Needs to be refactored
/********************************/
function reloadPage() {
    var reloadButton = document.getElementById('reloadButton').getElementsByTagName('input')[0];
    reloadButton.click();
}

/********************************/
// Show working
// Needs to be refactored
/********************************/
function show_working(message, width) {
    var title = '';
    var content = '<p style="text-align:center;">' + message + ' <img src="/images/working.gif" alt=""></p>';
    var buttons = '';
    if (width === '' || width === 'undefined') {
        width = 30;
    }
    if (message === 'undefined') {
        message = '';
    }

    /* jshint -W117 */
    sits_dialog(title, content, buttons, false, true, false, false, sits_dialog, true, width);
    /* jshint +W117 */

    return true;
}